<template>
    <div class="relative pb-8 -mt-4 z-50">
        <div class="flex flex-1">
            <document-tabs
                current_tab="signatures"
                :documents_index_route="documents_index_route"
                :signatures_index_route="signatures_index_route"
            />
        </div>

        <div class="w-full flex flex-wrap justify-end items-center gap-4 bg-gray-100 px-4 py-4 mt-12 mb-4 border border-gray-300">
            <button-blue-outline
                v-if="has_active_docusign_user && envelopes_available && !creating && !envelope"
                @click="createEnvelope"
            >
                {{ $t('Create Envelope') }}
            </button-blue-outline>
            <button-blue-outline @click="purchaseDocusignCredit">
                {{ $t('Buy Docusign envelope packs') }}
            </button-blue-outline>
        </div>

        <div v-if="! creating && ! envelope"
            class="absolute top-0 right-0"
        >
            <docusign-status
                :has_active_docusign_user="has_active_docusign_user"
                :docusign_user="docusign_user"
                :envelopes_available="envelopes_available"
            />
        </div>

        <div v-if="creating || envelope"
            class="mt-6 pb-6"
        >
            <envelope-detail
                :envelope="envelope"
                :property="property"
                :documents="documents"
                :templates="templates"
                :document_folders="document_folders"
                :envelope_count="envelopes?.length || 0"
                :envelopes_available="envelopes_available"
                :signatures_view_docusign_route="signatures_view_docusign_route"
                :signatures_create_route="signatures_create_route"
                :signatures_index_route="signatures_index_route"
                :signatures_destroy_route="signatures_destroy_route"
                :signature_purchase_route="signature_purchase_route"
                :prompt_for_broker_completion="prompt_for_broker_completion"
                @cancel="cancelCreateEnvelope"
            />
        </div>

        <div v-else-if="docusign_user && docusign_user.error">
            <p class="text-md text-red-600 mt-8">
                There was an error activating your Docusign account. <br>
                Please contact Support for assistance.
            </p>
        </div>

        <div v-else-if="! docusign_user">
            <p class="text-md text-blue-600 mt-8">
                Docusign access is being activated on your account, and will be available shortly.
            </p>
        </div>

        <div v-else-if="has_active_docusign_user">
            <p v-if="! envelopes.length"
                class="text-base text-gray-500 mt-8"
            >
                To request signatures using Docusign, add one or more documents to an Envelope.
            </p>

            <envelope-list
                :property="property"
                :envelopes="envelopes"
            />
        </div>
    </div>
</template>

<script>
import ButtonBlueOutline from '../../../components/button-blue-outline.vue';
import DocusignStatus from './docusign-status.vue';
import DocumentTabs from '../document-tabs.vue';
import EnvelopeDetail from './envelope-detail.vue';
import EnvelopeList from './envelope-list.vue';

export default {
    components: {
        ButtonBlueOutline,
        DocusignStatus,
        DocumentTabs,
        EnvelopeDetail,
        EnvelopeList,
    },

    props: {
        property: {},
        documents: {},
        templates: {},
        document_folders: {},
        envelopes: {},
        envelope: {},
        index_route: {},
        read_only: { default: false },
        has_active_docusign_user: { default: false },
        docusign_user: {},
        envelopes_available: {},
        docusign_event: {},
        store_route: {},
        documents_index_route: {},
        signature_purchase_route: {},
        signatures_index_route: {},
        signatures_create_route: {},
        signatures_destroy_route: {},
        signatures_view_docusign_route: {},
        prompt_for_broker_completion: {},
    },

    data() {
        return {
            creating: false,
            show_broker_completion_modal: false,
        }
    },

    methods: {
        createEnvelope() {
            this.creating = true;
        },
        cancelCreateEnvelope() {
            this.creating = false;
        },
        purchaseDocusignCredit() {
            window.location.href = this.signature_purchase_route;
        },
    },
}
</script>
